import { pxToRem } from "../base.js"
import { palette } from "../palette.js"

export const MuiTextField = {
  styleOverrides: {
    root: {
      // backgroundColor: palette.background2,
      // "&:hover, &:focus": {
      //   backgroundColor: palette.background2,
      // }

      //TODO Update Root component styles after marge with latest component modifications
      "& .MuiInputLabel-shrink": {
        display: "none",
        "& + .MuiInputBase-root .MuiInputBase-input": {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      // TODO Supposed to be included in the latest version of the TextField (removes input arrows)
      ["input::-webkit-outer-spin-button" && "input::-webkit-inner-spin-button"]: {
        WebkitAppearance: "none",
        margin: 0,
      },
      input: {
        MozAppearance: "textfield",
      },
    },
  },
}
